module.exports = __webpack_public_path__ + "static/media/peacock.bcb09d3d.ogg";